import React from "react";
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Constant from "../../../../../mxGraph/HCLTreeNode/HCLTreeVertexValue/Constant";
import Grid from "@material-ui/core/Grid";

interface Props {
  constant: Constant;
  onChange: (e: React.ChangeEvent<HTMLInputElement>, name: string) => void;
  name: string;
}

class ConstantInput extends React.Component<Props> {

  private handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { onChange, name } = this.props;
    onChange(e, name);
  };

  render() {
    const { constant } = this.props;

    const value = constant.getValue();

    return (
      <Grid item>
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                checked={value}
                onChange={this.handleChange}
                value={value}
                name="value"
                color="primary"
              />
            }
            label={value ? "On" : "Off"}
          />
        </FormGroup>
      </Grid>
    )
  }
}

export default ConstantInput;
